export default __webpack_public_path__ + "static/media/wrong-icon.c62ef5b2.svg";